export const fr = {
    NAV: {
        DASHBOARD: "Tableau de Bord",
        PRODUCTS: "Produits",
        INVENTORY: "Inventaire",
        SUPPLIERS: "Fournisseurs",
        EVENTS: "Événements",
        SALES_IMPORT: "Import Ventes",
        REPORTS: "Rapports",
        SETTINGS: "Paramètres",
        SIGNOUT: "Se déconnecter"
    },
    COMMON: {
        CANCEL: "Annuler",
        SAVE: "Enregistrer",
        DELETE: "Supprimer",
        EDIT: "Modifier",
        CONFIRM: "Confirmer",
        SEARCH: "Rechercher...",
        LOADING: "Chargement...",
        NO_DATA: "Aucune donnée disponible",
        ACTIONS: "Actions",
        DATE: "Date",
        STATUS: "Statut",
        NOTES: "Notes",
        COPY: "Copier",
        CLOSE: "Fermer"
    },
    DASHBOARD: {
        TITLE: "Tableau de Bord",
        SUBTITLE: "Aperçu de votre activité en temps réel.",
        LOW_STOCK: "Stock Faible",
        TOTAL_STOCK_VALUE: "Valeur du Stock",
        COMPLETED_EVENTS: "Événements Terminés",
        TOTAL_REVENUE: "Chiffre d'Affaires Total",
        YEAR_REVENUE: "Chiffre d'Affaires",
        LAST_EVENT: "Dernier Événement",
        NO_EVENT_REVENUE: "Aucun événement récent",
        AVG_BASKET: "Panier Moyen",
        TOP_PRODUCTS: "Top Produits du Mois",
        UPCOMING_EVENT: "Prochain Événement",
        NO_UPCOMING_EVENT: "Aucun événement prévu",
        ITEMS_NEED_RESTOCK: "articles à commander",
        VIEW_ALERTS: "Voir les alertes",
        UNITS: "unités",
        GUESTS: "invités",
        DAYS_UNTIL: "J-"
    },
    PRODUCTS: {
        TITLE: "Produits",
        SUBTITLE: "Gérez votre catalogue, les prix et les niveaux de stock.",
        ADD_PRODUCT: "Ajouter un Produit",
        TABLE: {
            PRODUCT: "Produit",
            CATEGORY: "Catégorie",
            FORMAT: "Format",
            COST: "Coût",
            PRICE: "Prix Vente",
            STOCK: "Stock",
            VALUE: "Valeur"
        },
        MODAL: {
            ADD_TITLE: "Nouveau Produit",
            EDIT_TITLE: "Modifier le Produit",
            DESC: "Remplissez les détails ci-dessous.",
            BRAND: "Marque",
            NAME: "Nom du Produit",
            CATEGORY: "Catégorie",
            UNIT: "Format / Unité",
            SUPPLIER: "Fournisseur (pour réappro)",
            COST_PRICE: "Prix d'Achat (€)",
            SELL_PRICE: "Prix de Vente (€)",
            ABV: "Degré Alcool (%)"
        },
        SEARCH_PLACEHOLDER: "Rechercher par marque ou nom...",
        FILTER_ALL: "Toutes les Catégories",
        EMPTY: {
            TITLE: "Construisez votre Catalogue",
            DESC: "Ajoutez votre premier produit pour suivre le stock et les marges.",
            BTN: "Ajouter Premier Produit",
            NO_RESULTS: "Aucun produit trouvé",
            CLEAR_FILTERS: "Effacer les filtres"
        }
    },
    INVENTORY: {
        TITLE: "Inventaire",
        SUBTITLE: "Suivi des mouvements et corrections de stock.",
        ADD_MOVEMENT: "Ajouter Mouvement",
        TAB_STOCK: "Stock Actuel",
        TAB_HISTORY: "Historique",
        TAB_AUDIT: "Inventaire (Audit)",
        TABLE: {
            DETAILS: "Détails",
            UNIT_COST: "Coût Unitaire",
            QUANTITY: "Quantité",
            TIME: "Heure",
            TYPE: "Type",
            PERFORMED_BY: "Par",
            REASON: "Raison"
        },
        AUDIT: {
            MODE_TITLE: "Mode Inventaire",
            MODE_DESC: "Entrez les comptages réels. Les écarts seront ajustés automatiquement.",
            SYSTEM_STOCK: "Stock Système",
            ACTUAL_COUNT: "Comptage Réel",
            FINALIZE: "Finaliser & Ajuster",
            MATCH: "Ok",
            FOUND: "Trouvé",
            LOSS: "Perte"
        },
        MODAL: {
            TITLE: "Mouvement de Stock",
            TYPE_IN: "Entrée (+)",
            TYPE_OUT: "Sortie (-)",
            SELECT_PRODUCT: "Sélectionner Produit",
            QTY: "Quantité",
            REASON_LABEL: "Raison",
            REASONS: {
                restock: "Réapprovisionnement",
                correction: "Correction",
                return: "Retour",
                sale: "Vente",
                waste: "Perte / Casse",
                gift: "Offert / Staff"
            }
        }
    },
    SUPPLIERS: {
        TITLE: "Fournisseurs",
        SUBTITLE: "Gérez vos fournisseurs et le réapprovisionnement.",
        ADD_SUPPLIER: "Ajouter Fournisseur",
        NO_SUPPLIERS: "Aucun fournisseur",
        NO_SUPPLIERS_DESC: "Ajoutez votre premier fournisseur pour commencer.",
        GENERATE_ORDER: "Générer Commande",
        ORDER_MODAL: {
            TITLE: "Commande pour",
            COPY_TEXT: "Copier le texte"
        },
        MODAL: {
            ADD_TITLE: "Nouveau Fournisseur",
            EDIT_TITLE: "Modifier Fournisseur",
            COMPANY: "Nom de la Société",
            CONTACT: "Contact",
            EMAIL: "Email",
            PHONE: "Téléphone"
        }
    },
    EVENTS: {
        TITLE: "Événements",
        SUBTITLE: "Planifiez et suivez les consommations par événement.",
        ADD_EVENT: "Créer Événement",
        STATUS: {
            upcoming: "À venir",
            active: "En cours",
            completed: "Terminé",
            cancelled: "Annulé"
        }
    },
    SETTINGS: {
        TITLE: "Paramètres",
        SUBTITLE: "Gestion des utilisateurs et préférences.",
        USERS: "Utilisateurs",
        ROLES: {
            SUPER_ADMIN: "Super Admin",
            ADMIN: "Administrateur",
            STAFF: "Staff"
        }
    },
    RECIPES: {
        TITLE: "Recettes",
        SUBTITLE: "Gérez vos fiches techniques cocktails et calculez vos marges/servings.",
        ADD_RECIPE: "Ajouter une Recette",
        SEARCH_PLACEHOLDER: "Rechercher une recette...",
        SERVINGS: "verres",
        AVAILABLE: "Disponibles",
        INGREDIENTS: "Ingrédients",
        NO_RECIPES: {
            TITLE: "Créez votre première carte",
            DESC: "Ajoutez vos cocktails pour suivre les coûts et la faisabilité.",
            BTN: "Créer Premier Cocktail"
        },
        MODAL: {
            ADD_TITLE: "Nouveau Cocktail",
            EDIT_TITLE: "Modifier la Recette",
            NAME: "Nom du Cocktail",
            INSTRUCTIONS: "Instructions",
            ADD_INGREDIENT: "Ajouter Ingrédient",
            SELECT_PRODUCT: "Produit",
            QTY: "Quantité (cl/unit)",
            UNIT: "Unité",
            REMOVE: "Retirer"
        }
    },
    IMPORT_WIZARD: {
        TITLE: "Importer des Ventes",
        STEP_UPLOAD: "Télécharger",
        STEP_MAP: "Mapper",
        STEP_REVIEW: "Vérifier",
        UPLOAD_TITLE: "Cliquez pour télécharger CSV ou XLSX",
        UPLOAD_DESC: "Compatible avec les exports SumUp",
        SELECT_FILE: "Sélectionner un Fichier",
        LINK_EVENT: "Lier à un Événement (Optionnel)",
        SELECT_EVENT: "Sélectionner un événement...",
        FOUND_ITEMS: "Trouvé",
        UNIQUE_ITEMS: "articles uniques",
        UNMAPPED: "non mappés",
        ALL_MAPPED: "Tous mappés !",
        AUTO_MATCH: "Auto-Correspondance",
        IMPORTED_NAME: "Nom Importé",
        MAPS_TO: "Correspond à",
        SELECT_ITEM: "-- Sélectionner --",
        CREATE_NEW: "+ Créer Nouveau Produit",
        IGNORE: "Ne pas Suivre (Ignorer)",
        READY_TITLE: "Prêt à Importer",
        READY_DESC: "Vous êtes sur le point d'importer des données de vente",
        TOTAL_TRANSACTIONS: "Total Transactions",
        MAPPED_PRODUCTS: "Produits Mappés",
        BTN_BACK: "Retour",
        BTN_NEXT: "Suivant",
        BTN_CONFIRM: "Confirmer & Importer"
    },
    IMPORTS: {
        TITLE: "Imports de Ventes",
        SUBTITLE: "Téléchargez des rapports CSV depuis votre POS (SumUp) pour mettre à jour l'inventaire",
        NEW_IMPORT: "Nouvel Import",
        TABLE: {
            REFERENCE: "Référence",
            EVENT: "Événement Lié",
            STATUS: "Statut",
            TRANSACTIONS: "Transactions",
            TOTAL: "Total Traité",
            ACTIONS: "Actions"
        },
        STATUS: {
            COMPLETED: "Terminé",
            PROCESSING: "En cours",
            FAILED: "Échoué"
        },
        ITEMS: "articles",
        DELETE_CONFIRM: "Êtes-vous sûr de vouloir supprimer cet import ? Cela supprimera l'enregistrement et les lignes associées, mais NE REVIENDRA PAS les changements de stock.",
        EMPTY: {
            TITLE: "Aucun import",
            DESC: "Téléchargez votre premier rapport de ventes pour commencer",
            BTN: "Démarrer Import"
        }
    },
    EVENTS_MODAL: {
        ADD_TITLE: "Nouvel Événement",
        EDIT_TITLE: "Modifier l'Événement",
        ADD_DESC: "Créez un nouvel événement pour suivre les ventes",
        EDIT_DESC: "Modifiez les détails de l'événement",
        BTN_CREATE: "Créer Événement",
        BTN_UPDATE: "Mettre à Jour",
        EVENT_NAME: "Nom de l'Événement",
        EVENT_NAME_PLACEHOLDER: "ex: Summer Party",
        DATE: "Date",
        VENUE: "Lieu",
        VENUE_PLACEHOLDER: "Main Hall",
        EXPECTED_GUESTS: "Invités Attendus"
    },
    SUPPLIERS_MODAL: {
        ADD_DESC: "Ajoutez un nouveau fournisseur à votre liste",
        EDIT_DESC: "Modifiez les détails du fournisseur"
    },
    INVENTORY_MODAL: {
        TITLE: "Mouvement de Stock",
        ADD_STOCK: "+ Ajouter Stock",
        REMOVE_STOCK: "- Retirer Stock",
        ACTION_TYPE: "Type d'Action",
        PRODUCT: "Produit",
        QUANTITY: "Quantité",
        REASON: "Raison",
        NOTES: "Notes",
        NOTES_PLACEHOLDER: "Détails optionnels (ex: Facture #)",
        CONFIRM: "Confirmer"
    },
    UI: {
        SELECT_PLACEHOLDER: "Sélectionner...",
        LOADING: "Chargement...",
        NO_RESULTS: "Aucun résultat",
        DELETE_IMPORT: "Supprimer Import",
        DELETE_EVENT: "Supprimer Événement",
        DELETE_USER: "Supprimer Utilisateur"
    },
    REPORTS: {
        TITLE: "Rapports & Exports",
        SUBTITLE: "Téléchargez les données pour analyse et archivage",
        INVENTORY: {
            TITLE: "Inventaire Actuel",
            DESC: "Exportez le catalogue complet avec les niveaux de stock, coûts et valorisation totale",
            BTN: "Exporter Inventaire"
        },
        MOVEMENTS: {
            TITLE: "Mouvements de Stock",
            DESC: "Journal complet de tous les changements de stock (achats, ventes, pertes) avec horodatage et attribution utilisateur",
            BTN: "Exporter Journal"
        },
        EVENTS: {
            TITLE: "Résumé Événements",
            DESC: "Détail de tous les événements, incluant nombre d'invités, revenus totaux et statut de complétion",
            BTN: "Exporter Événements"
        }
    },
    EVENTS: {
        TITLE: "Événements",
        SUBTITLE: "Planifiez les soirées à venir et analysez les performances passées",
        CREATE_BTN: "Créer Événement",
        COMPLETED: "Terminé",
        UPCOMING: "À venir",
        EDIT: "Modifier",
        DELETE_CONFIRM: "Êtes-vous sûr de vouloir supprimer cet événement ? Cette action ne peut pas être annulée.",
        NO_VENUE: "Aucun lieu défini",
        GUESTS: "Invités",
        REVENUE: "Revenus",
        STATUS: {
            COMPLETED: "Terminé"
        }
    },
    SETTINGS: {
        TITLE: "Paramètres",
        SUBTITLE: "Gérez les accès et permissions de l'équipe",
        TEAM_MEMBERS: "Membres de l'Équipe",
        ACTIVE_USERS: "utilisateurs actifs",
        TABLE: {
            USER: "Utilisateur",
            EMAIL: "Email",
            ROLE: "Rôle",
            ACTION: "Action"
        },
        ROLES: {
            SUPER_ADMIN: "Super Admin",
            ADMIN: "Admin",
            STAFF: "Staff"
        },
        YOU: "Vous",
        IMMUTABLE: "Immuable",
        DEMOTE: "Rétrograder en Staff",
        PROMOTE: "Promouvoir en Admin",
        DELETE_USER: "Supprimer Utilisateur",
        DELETE_CONFIRM: "Êtes-vous sûr de vouloir supprimer l'utilisateur",
        NO_USERS: "Aucun utilisateur trouvé",
        PERMISSIONS_GUIDE: {
            TITLE: "Guide des Permissions",
            ADMIN: "peuvent gérer les produits, voir tous les rapports et gérer les autres utilisateurs",
            STAFF: "peuvent uniquement voir l'inventaire et les produits, et créer des imports de ventes basiques"
        },
        DANGER_ZONE: {
            TITLE: "Zone Dangereuse",
            RESET_TITLE: "Réinitialiser la Base de Données",
            RESET_DESC: "Cette action supprimera définitivement tous les PRODUITS, ÉVÉNEMENTS, IMPORTS et MOUVEMENTS. Les comptes utilisateurs et paramètres seront préservés. Cette action ne peut pas être annulée.",
            RESET_BTN: "Réinitialiser Base de Données",
            RESET_CONFIRM_1: "ATTENTION CRITIQUE : Vous êtes sur le point de SUPPRIMER TOUTES LES DONNÉES (Produits, Événements, Stock). Êtes-vous absolument sûr ?",
            RESET_CONFIRM_2: "Cette action ne peut pas être annulée. Tapez \"DELETE\" dans la console si vous voulez vraiment... Je plaisante, cliquer OK suffit mais soyez prudent !",
            CLEARING: "Suppression...",
            SUCCESS: "Base de données effacée avec succès",
            FAILED: "Échec de la réinitialisation de la base de données : "
        }
    }
};
